import { render, staticRenderFns } from "./Usage.vue?vue&type=template&id=2deb021f&lang=pug&"
import script from "./Usage.vue?vue&type=script&lang=ts&"
export * from "./Usage.vue?vue&type=script&lang=ts&"
import style0 from "./Usage.vue?vue&type=style&index=0&id=2deb021f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports